import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { LateFeesSettings, LateFeesSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const LATE_FEE_SETTING_URL = `${SETTINGS_BASE_URL}/latefees`;
const TEST_LATE_FEE_FORMULA_URL = `${LATE_FEE_SETTING_URL}/test/formula`;

export class LateFeesSettingsRepository extends BaseRestRepository {
  public async addLateFeesSettings(payload: LateFeesSettings) {
    const url = `${LATE_FEE_SETTING_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async addLateFeesSettingsByLevel(level: string, levelId: string, payload: LateFeesSettings) {
    const url = LATE_FEE_SETTING_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response);
  }

  public async getLateFeesSettings(): Promise<LateFeesSettings> {
    const url = `${LATE_FEE_SETTING_URL}/company`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getLateFeesSettingsByLevel(level: string, levelId: string) {
    const url = `${LATE_FEE_SETTING_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getAllLateFeesSettings(): Promise<LateFeesSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${LATE_FEE_SETTING_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async deleteLateFeesSettingsByLevel(level: string, levelId: string) {
    const url = `${LATE_FEE_SETTING_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }

  public async testLateFeeFormula(payload: { formula: string; [key: string]: number | string }): Promise<{ result: number }> {
    const url = TEST_LATE_FEE_FORMULA_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }
}

export const lateFeesSettingsRepository = new LateFeesSettingsRepository();
